<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<a class="right" id="page15">15</a>
<h1><a id="P1">Part I<br/>The Fundamentals</a></h1><a id="P1">
<div class="image"><img alt="image" src="images/0005.jpg"/></div>
</a></div><a id="P1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_1.vue?60045351